import { render, staticRenderFns } from "./ContractPeriod.vue?vue&type=template&id=876a1dd8&"
import script from "./ContractPeriod.vue?vue&type=script&lang=js&"
export * from "./ContractPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports